import {JsonAdapter} from "../helpers/JsonAdapter";
import {Vacancy} from "./Vacancy";
import {Applicant} from "./Applicant";
import {Project} from "./Project";
import {ApplicationForm} from "./ApplicationForm";
import {ApplicationOption} from "./ApplicationOption";
import {EnvironmentService} from "../services/environment.service";

export class Application {
  id: string = "";
  vacancy!: Vacancy;
  organisation_name?: string = "";
  applicant?: Applicant;
  created_at: string = "";
  job_title: string = "";
  application_form!: ApplicationForm;
  current_role_and_area?: string = "";
  current_manager?: string = "";
  answers: any[] = [];
  priority: number = 0;
  status: string = "";
  outcome: string = "";
  outcome_individual: string = "";
  application_option!: ApplicationOption;

  attachment: any[] = [];
  archived_by_candidate = false;

  static create(object:any, env: EnvironmentService | null = null): Application {
    const item = JsonAdapter.fill(new Application(), object);

    if(object.vacancy) {
      item.vacancy = Vacancy.create(object.vacancy, env);
    }

    if(object.applicant) {
      item.applicant = Applicant.create(object.applicant);
    }

    if(object.application_form) {
      item.application_form = ApplicationForm.create(object.application_form);
    }

    if(object.answers) {
      item.answers = object.answers;
    }

    if(object.attachment) {
      item.attachment = object.attachment;
    }

    if(object.application_option) {
      item.application_option = ApplicationOption.create(object.application_option);
    }

    return item;
  }

  static createMultiple(objects: Application[]): Application[] {
    const items = [];
    for (let i = 0; i < objects.length; i++) {
      items.push(Application.create(objects[i]));
    }
    return items;
  }

  get priorityLabel(): string {
    switch (this.priority) {
      case 1:
        return '1st priority';
      case 2:
        return '2nd priority';
      case 3:
        return '3rd priority';
      default:
        return 'Not set';
    }
  }

  isOpen() {
    return this.vacancy.isOpen();
  }

  get statusInfo() {
    switch (this.status) {
      case 'pending':
        return {
          label: 'Pending',
          class: 'text-warning',
          buttonClass: 'btn-warning',
          icon: 'faClock'
        };
      case 'shortlisted':
        return {
          label: 'Shortlisted',
          class: 'text-primary',
          buttonClass: 'btn-primary',
          icon: 'faTrophy'
        };
      case 'recruited':
        return {
          label: 'Recruited',
          class: 'text-success',
          buttonClass: 'btn-success',
          icon: 'faCheck'
        };
      case 'declined':
        return {
          label: 'Declined',
          class: 'text-danger',
          buttonClass: 'btn-danger',
          icon: 'faCircleXmarkSolid'
        }
      default:
        return {
          label: 'Unknown',
          class: 'text-muted',
          buttonClass: 'btn-white',
          icon: 'faQuestion'
        }
    }
  }

  get displayedOutcome() {
    switch (this.outcome) {
      case 'interviewed_but_not_hired':
        return 'Interviewed but not hired';
      case 'application_not_completed':
        return 'Application not completed';
      case 'hired':
        return 'Hired';
      case 'not_selected_for_interview':
        return 'Not selected for interview';
    }

    return "Change Outcome";
  }

  get displayedOutcomeIndividual() {
    switch (this.outcome_individual) {
      case 'withdrawn_interest':
        return 'Withdrawn Interest';
      case 'applied_on_company_site':
        return 'Applied on Company Site';
      case 'hired':
        return 'Hired';
      case 'application_unsuccessful':
        return 'Application Unsuccessful';
    }

    return "Change Outcome";
  }
}
